var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "mx-1": "" } },
    [
      _c(
        "v-flex",
        { staticClass: "form-section", attrs: { xs12: "", md6: "" } },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("1")]),
                _vm._v(" "),
                _c("div", { staticClass: "red--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text " }, [
                _vm._v(
                  _vm._s(_vm.$t(_vm.lblSetting.bmInspectionBundleSing) + " ?")
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            { attrs: { required: "", label: _vm.lblSetting.bmBundleSing } },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.coCharacterProblems,
                  "item-value": "id",
                  "item-text": "name",
                  solo: ""
                },
                model: {
                  value: _vm.IB,
                  callback: function($$v) {
                    _vm.IB = $$v
                  },
                  expression: "IB"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.ibIc.length
            ? _c(
                "base-control-label-vertical",
                { attrs: { label: _vm.lblSetting.bmICLinked } },
                _vm._l(_vm.ibIc, function(item, index) {
                  return _c(
                    "div",
                    [
                      _c("v-checkbox", {
                        staticClass: "mt-0 pt-0 mb-2",
                        attrs: {
                          label: item.firstname + " " + item.lastname,
                          color: "primary",
                          "hide-details": ""
                        },
                        on: { change: _vm.changeBundleIC },
                        model: {
                          value: item.selected,
                          callback: function($$v) {
                            _vm.$set(item, "selected", $$v)
                          },
                          expression: "item.selected"
                        }
                      })
                    ],
                    1
                  )
                })
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "form-section",
          attrs: { "pl-3": "", xs12: "", md6: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("2")]),
                _vm._v(" "),
                _c("div", { staticClass: "red--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text" }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.bmCustomisation)))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            {
              attrs: { xs4: "", label: "" + _vm.$t(_vm.lblSetting.bmIBColor) }
            },
            [
              _c("v-swatches", {
                staticClass: "mx-3",
                staticStyle: { "max-width": "350px" },
                attrs: {
                  "background-color": "transparent",
                  swatches: _vm.swatch.colors,
                  "swatch-style": _vm.swatch.style,
                  inline: ""
                },
                model: {
                  value: _vm.Color,
                  callback: function($$v) {
                    _vm.Color = $$v
                  },
                  expression: "Color"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e34b093", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e34b093","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/building-monitor/components/bm-ib-modal-vertical/template.html
// module id = null
// module chunks = 